import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import SimpleResponse from 'shared/api/model/SimpleResponse';
import createHttpRequest from 'shared/api/http';

export const emailConfirmationRequest =
    createAsyncThunk<SimpleResponse, void>('auth/emailConfirmationRequest', async() => {
        const response = await createHttpRequest({
            method: 'GET',
            path: ApiUrls.EMAIL_RECONFIRM,
        });

        return response.data;
    });
